import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthenticationService} from './authentication.service';
import {Permission} from '../_enums/permission.enum';

@Injectable()
export class RegistrarClienteGuardService {
	constructor(private authenticationService: AuthenticationService, private router: Router) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
		const hasPermission = this.authenticationService.hasPermission(Permission.RegistrarCliente);
		if (hasPermission) {
			return true;
		} else {
			this.router.navigate(['/home']);
			return false;
		}
	}
}
